/* eslint-disable camelcase */
export function spNavClick({ location, url, category, selection }) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'sp_nav_click',
        navigation: {
            nav_location: location,
            nav_url_clicked: url,
            nav_category: category,
            nav_selection: selection,
        },
    });
}